import { getRemoteConfigValues } from '@/lib/remote-config/client';

export type InAppPaywallDesign = 0 | 1 | 2 | 3;

export type InAppPaywallConfig = Readonly<{
  design: InAppPaywallDesign;
}>;

export const DEFAULT_IN_APP_PAYWALL_CONFIG: InAppPaywallConfig = {
  design: 1,
};

const REMOTE_CONFIG_DEFAULTS = {
  inAppPaywall: JSON.stringify(DEFAULT_IN_APP_PAYWALL_CONFIG),
} as const;

const isSupportedDesign = (value: unknown): value is InAppPaywallDesign =>
  value === 0 || value === 1 || value === 2 || value === 3;

export const parseInAppPaywallConfig = (
  value: string | null | undefined
): InAppPaywallConfig => {
  if (!value) {
    return DEFAULT_IN_APP_PAYWALL_CONFIG;
  }

  try {
    const config: unknown = JSON.parse(value);

    if (
      typeof config === 'object' &&
      config !== null &&
      !Array.isArray(config) &&
      isSupportedDesign((config as { design?: unknown }).design)
    ) {
      return { design: (config as { design: InAppPaywallDesign }).design };
    }
  } catch {
    // Invalid Firebase Remote Config JSON uses the safe Design 1 fallback.
  }

  return DEFAULT_IN_APP_PAYWALL_CONFIG;
};

export const getInAppPaywallConfig = async (): Promise<InAppPaywallConfig> => {
  const { inAppPaywall } = await getRemoteConfigValues(REMOTE_CONFIG_DEFAULTS);

  return parseInAppPaywallConfig(inAppPaywall);
};
